import { createContext, ReactNode, useContext, useRef } from "react";
import { AxiosConfigurer } from "@eaigle/api/AxiosConfigurer";

interface ServicesContextProps {
  axiosConfigurer: AxiosConfigurer;
}

const ServicesContext = createContext<ServicesContextProps>({} as ServicesContextProps);

export const ServicesProvider = ({ children }: { children: ReactNode }) => {
  const servicesRef = useRef<ServicesContextProps | null>(null);
  if (!servicesRef.current) {
    const axiosConfigurer = new AxiosConfigurer(
      typeof import.meta.env.VITE_BASE_URL === "string" ?
        import.meta.env.VITE_BASE_URL
      : "",
    );
    servicesRef.current = {
      axiosConfigurer,
    };
  }

  return (
    <ServicesContext.Provider value={servicesRef.current}>
      {children}
    </ServicesContext.Provider>
  );
};

export const useServices = () => {
  const servicesContext = useContext(ServicesContext);
  if (!servicesContext) {
    throw new Error("useServices must be used within a ServicesProvider");
  }
  return servicesContext;
};
